<footer class="min-w-full bg-white xl:mt-[180px] lg:mt-[140px] mt-[120px]">
    <div class="container">
        <mat-divider></mat-divider>

        <div class="grid justify-between lg:grid-cols-[repeat(3,auto)] sm:grid-cols-[repeat(2,auto)] max-sm:grid-rows-[repeat(3,auto)] max-lg:gap-y-12 max-lg:w-[650px] max-md:w-[560px] max-sm:w-min max-lg:m-[auto] pt-14">
            <div class="xl:w-[300px] lg:w-[275px] w-full max-lg:col-span-2 max-sm:col-span-1">
                <img [src]="data()?.logos?.logo" alt="Receeto logo" routerLink="/" class="rc2-logo mb-[22px]">
                <p class="paragraph-normal pb-6">It is a long established fact that from will be distracted by the readable from when looking.</p>
                
                @if (data()?.contact_info?.email) {
                    <div class="flex items-center gap-2.5 mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="xl:h-6 xl:w-6 h-[22px] w-[22px]">
                            <path fill="#7857E6" d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"/>
                        </svg>
                        <p class="paragraph-normal">{{ data()?.contact_info.email }}</p>
                    </div>
                }
                @if (data()?.contact_info?.phone_number) {
                    <div class="flex items-center gap-2.5">
                        <svg viewBox="0 0 22 23" class="xl:w-5 xl:h-[22px] w-[18px] h-5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_3300_3117)">
                                <path d="M13.7955 5.08366C14.6908 5.25834 15.5137 5.69623 16.1587 6.34127C16.8038 6.9863 17.2416 7.80915 17.4163 8.70449L13.7955 5.08366ZM13.7955 1.41699C15.6557 1.62364 17.3903 2.45665 18.7145 3.77925C20.0388 5.10185 20.874 6.83542 21.083 8.69533L13.7955 1.41699ZM20.1663 16.0103V18.7603C20.1674 19.0156 20.1151 19.2683 20.0128 19.5022C19.9105 19.7361 19.7605 19.9461 19.5724 20.1187C19.3843 20.2913 19.1622 20.4227 18.9203 20.5045C18.6785 20.5863 18.4222 20.6166 18.168 20.5937C15.3473 20.2872 12.6377 19.3233 10.2572 17.7795C8.04233 16.3721 6.16455 14.4943 4.75715 12.2795C3.20797 9.8881 2.24388 7.1654 1.94299 4.33199C1.92008 4.0785 1.95021 3.82302 2.03145 3.58181C2.11269 3.34061 2.24326 3.11896 2.41486 2.93098C2.58645 2.743 2.79531 2.59281 3.02813 2.48997C3.26095 2.38713 3.51263 2.3339 3.76715 2.33366H6.51715C6.96202 2.32928 7.3933 2.48681 7.7306 2.7769C8.06791 3.06698 8.28822 3.46982 8.35049 3.91033C8.46656 4.79039 8.68182 5.65449 8.99215 6.48616C9.11549 6.81426 9.14218 7.17083 9.06907 7.51363C8.99596 7.85643 8.82611 8.17109 8.57965 8.42033L7.41549 9.58449C8.72041 11.8794 10.6206 13.7796 12.9155 15.0845L14.0797 13.9203C14.3289 13.6739 14.6435 13.504 14.9863 13.4309C15.3291 13.3578 15.6857 13.3845 16.0138 13.5078C16.8455 13.8182 17.7096 14.0334 18.5897 14.1495C19.0349 14.2123 19.4416 14.4366 19.7323 14.7797C20.023 15.1228 20.1775 15.5608 20.1663 16.0103Z" stroke="#7857E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_3300_3117">
                                    <rect width="22" height="22" fill="white" transform="translate(0 0.5)"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <p class="paragraph-normal">{{ data()?.contact_info.phone_number }}</p>
                    </div>
                }
            </div>

            <div class="xl:w-[270px] sm:w-[240px] w-[280px] max-sm:m-[auto]">
                <div class="xl:text-2xl text-[22px] font-bold xl:mb-[50px] sm:mb-[38px] mb-7 max-sm:text-center">Pages</div>

                <div class="grid sm:grid-cols-2 grid-cols-3 sm:grid-rows-4 grid-rows-3 sm:gap-x-[30px] gap-x-6 gap-y-5 max-2xs:pl-6 [&>a]:min-w-20 [&>a]:font-normal [&>a]:xl:text-lg [&>a]:2xs:text-base [&>a]:text-sm [&>a]:text-outline [&>a]:hover:text-primary" style="grid-auto-flow: column;">
                    <a routerLink="/shoppers" routerLinkActive="!text-primary">Shoppers</a>
                    <a routerLink="/sellers" routerLinkActive="!text-primary">Sellers</a>
                    <a routerLink="/partners" routerLinkActive="!text-primary">Partners</a>
                    <a routerLink="/about-us" routerLinkActive="!text-primary">About Us</a>
                    <a routerLink="/blogs" routerLinkActive="!text-primary">Blogs</a>
                    <a routerLink="/contact-us" routerLinkActive="!text-primary">Contact Us</a>
                    <a routerLink="/login">Log In</a>
                </div>
            </div>

            <div class="xl:w-[330px] 2xs:w-[300px] w-[280px] px-7 xl:py-11 py-9 rounded-[50px] bg-background max-lg:ml-[auto] max-sm:mr-[auto]">
                <div class="flex flex-col justify-start xl:gap-2.5 gap-1.5 xl:mb-6 mb-5">
                    <h6 class="font-bold xl:text-base 2xs:text-sm text-xs text-primary">Download</h6>
                    <h3 class="2xs:text-2xl text-[22px] !leading-snug">Its suitable to all decvices and screens</h3>
                    <p class="paragraph-normal">It is a long established fact that a reader will be distracted layout.</p>
                </div>

                <div class="w-full flex justify-between [&>img]:2xs:h-[42px] [&>img]:h-[36px] [&>img]:xl:min-w-[132px] [&>img]:xl:max-w-[132px] [&>img]:2xs:min-w-[120px] [&>img]:2xs:max-w-[120px] [&>img]:min-w-[110px] [&>img]:max-w-[110px] [&>img]:hover:opacity-80 [&>img]:hover:cursor-pointer">
                    <img src="assets/images/google-play-btn.webp" routerLink="/coming-soon">
                    <img src="assets/images/app-store-btn.webp" routerLink="/coming-soon">
                </div>
            </div>
        </div>

        <mat-divider></mat-divider>
    
        <div class="py-5 flex items-center justify-between max-lg:flex-col-reverse max-lg:gap-4">
            <div class="text-center">
                <span class="paragraph-normal text-outline">Copyright © Receeto | Designed by Receeto Team - </span>
                <a class="paragraph-normal text-primary !font-semibold">Powered by Hostinger</a>
            </div>
            <div class="flex items-center justify-end gap-5 [&>a]:2xs:h-7 [&>a]:2xs:w-7 [&>a]:h-6 [&>a]:w-6 [&>a]:hover:opacity-80">
                @if (data()?.social_media?.linkedin_link) {
                    <a [href]="data()?.social_media.linkedin_link" target="_blank">
                        <img src="assets/logos/linkedin-logo.webp" alt="Receeto Linkedin logo" />
                    </a>
                }
                @if (data()?.social_media?.facebook_link) {
                    <a [href]="data()?.social_media.facebook_link" target="_blank">
                        <img src="assets/logos/facebook-logo.webp" alt="Receeto Facebook logo" />
                    </a>
                }
                @if (data()?.social_media?.instagram_link) {
                    <a [href]="data()?.social_media.instagram_link" target="_blank">
                        <img src="assets/logos/instagram-logo.webp" alt="Receeto Instagram logo" />
                    </a>
                }
                @if (data()?.social_media?.tiktok_link) {
                    <a [href]="data()?.social_media.tiktok_link" target="_blank">
                        <img src="assets/logos/tiktok-logo.webp" alt="Receeto Tiktok logo" />
                    </a>
                }
                @if (data()?.social_media?.youtube_link) {
                    <a [href]="data()?.social_media.youtube_link" target="_blank">
                        <img src="assets/logos/youtube-logo.webp" alt="Receeto Youtube logo" />
                    </a>
                }
                @if (data()?.social_media?.whatsapp_link) {
                    <a [href]="data()?.social_media.whatsapp_link" target="_blank">
                        <img src="assets/logos/whatsapp-logo.webp" alt="Receeto Whatsapp logo" />
                    </a>
                }
            </div>
        </div>
    </div>
</footer>